import { useState, useRef, useEffect } from 'react';
import './MusicPlayer.css';

const MusicPlayer = () => {
    const [isPlaying, setIsPlaying] = useState(false);
    const [isMuted, setIsMuted] = useState(false);
    const [hasStarted, setHasStarted] = useState(false);
    const [volume, setVolume] = useState(0.25);
    const audioRef = useRef(null);

    useEffect(() => {
        if (!audioRef.current) return;

        if (isPlaying) {
            const playPromise = audioRef.current.play();
            if (playPromise !== undefined) {
                playPromise.catch(error => {
                    console.error("Playback failed:", error);
                    setIsPlaying(false);
                });
            }
        } else {
            audioRef.current.pause();
        }
    }, [isPlaying]);

    useEffect(() => {
        if (audioRef.current) {
            audioRef.current.volume = isMuted ? 0 : volume;
        }
    }, [isMuted, volume]);

    const togglePlay = () => {
        if (!hasStarted) setHasStarted(true);
        setIsPlaying(prev => !prev);
    };

    const toggleMute = () => {
        setIsMuted((prev) => !prev);
    };

    const handleVolumeChange = (e) => {
        const val = parseFloat(e.target.value);
        setVolume(val);
    };

    return (
        <div className={`music-player ${hasStarted ? 'music-player--active' : ''}`}>
            <audio
                ref={audioRef}
                src="https://raw.githubusercontent.com/SillyTavern/SillyTavern-Content/main/assets/ambient/cityscape-medieval-market.mp3"
                loop
                crossOrigin="anonymous"
                onPlay={() => setIsPlaying(true)}
                onPause={() => setIsPlaying(false)}
            />

            <div className="music-player__info">
                <span className="music-player__icon">🎵</span>
                <div className="music-player__meta">
                    <span className="music-player__track">Medieval Ambient</span>
                    <span className="music-player__sub">Historical · Atmospheric</span>
                </div>
            </div>

            <div className="music-player__controls">
                <button
                    className={`music-player__btn music-player__btn--play ${isPlaying ? 'music-player__btn--playing' : ''}`}
                    onClick={togglePlay}
                    aria-label={isPlaying ? 'Pause music' : 'Play music'}
                    title={isPlaying ? 'Pause' : 'Click to play ambient music'}
                >
                    {isPlaying ? '⏸' : '▶'}
                </button>

                <div className="music-player__volume">
                    <button
                        className={`music-player__btn music-player__btn--mute ${isMuted ? 'music-player__btn--muted' : ''}`}
                        onClick={toggleMute}
                        aria-label={isMuted ? 'Unmute' : 'Mute'}
                        title={isMuted ? 'Unmute' : 'Mute'}
                    >
                        {isMuted ? '🔇' : '🔊'}
                    </button>
                    <input
                        type="range"
                        min="0"
                        max="1"
                        step="0.05"
                        value={isMuted ? 0 : volume}
                        onChange={handleVolumeChange}
                        className="music-player__slider"
                        aria-label="Volume"
                    />
                </div>
            </div>

            {!hasStarted && (
                <div className="music-player__hint">
                    ← Click ▶ to start ambient music
                </div>
            )}

            {isPlaying && (
                <div className="music-player__visualizer">
                    {[...Array(5)].map((_, i) => (
                        <div key={i} className={`music-player__bar music-player__bar--${i + 1}`}></div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default MusicPlayer;
